//#region imports
import React, {useEffect, useState, useRef} from 'react';

// custom components
import { ApiTitle, TabList, List, TableNumber, Callout, RequestHeader, RequestFields, HttpRequest} from '../../components/molecules';
import {Footer, Text, PageNavigator } from '../../components/atoms';
import { IntegrationRow } from '../../components/organisms'

// bootstrap
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
  
// images
import BookingCard from '../../assets/images/home/booking-card.png';

// swagger
import SwaggerUI from "swagger-ui-react";

// code block
import sample from '../../utils/code/postBookingBody';
import { CopyBlock, dracula} from "react-code-blocks";

// utils
import { Colors } from '../../styles';

// images
import GettingPRMBookings from '../../assets/images/getting-bookings/getting-prm-bookings.png';


//#endregion

//#region
const ResponseTable = (props) => {
    return (
        <div>
            <table class="table" style={{ }}>
                <thead style={{}}>
                    <tr style={{backgroundColor:Colors.PRM_LIGHT_BLUE}}>
                        <th style={{fontWeight:'bold', fontSize:14, color:'white' }} scope="col"><Text.TableHeader>Code</Text.TableHeader></th>
                        <th style={{fontWeight:'bold', fontSize:14, color:'white' }} scope="col"><Text.TableHeader>Description</Text.TableHeader></th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td scope="col"><Text.TableHeader bold={true}>200 OK</Text.TableHeader></td>
                        <td scope="col"><Text.TableBody>{'Indicates that the request was successful, the response object contains the polled bookings'}</Text.TableBody></td>
                    </tr>
                    <tr>
                        <td scope="col"><Text.TableHeader bold={true}>400 Bad Request</Text.TableHeader></td>
                        <td scope="col"><Text.TableBody>Indicates that the request was not found. </Text.TableBody></td>
                    </tr>
                    <tr>
                        <td scope="col"><Text.TableHeader bold={true}>403 Unauthorized Access</Text.TableHeader></td>
                        <td scope="col"><Text.TableBody>{'Indicates that the request is unauthorized. Typically the result of not including the Authorization header in the request.'}</Text.TableBody></td>
                    </tr>
                    <tr>
                        <td scope="col"><Text.TableHeader bold={true}>500 Internal Server Error</Text.TableHeader></td>
                        <td scope="col"><Text.TableBody>{'Indicates that the request did not go through due to an internal error.'}</Text.TableBody></td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}
//#endregion

const GettingUpdatedDeleted = (props) => {

    // control tab
    const [tab, setTab] = useState(1)

    const border = false; 
    const ssrRef = useRef(null)
    const executeScroll = () => ssrRef.current.scrollIntoView()    

    useEffect(() => {

    }, []);

    const [STATE, SETSTATE] = useState(false)

    return (
        <>
            {/* Title and Prerequisities */}
            <Row className='mt-5'>
                <Col>
                    <ApiTitle 
                        smallTitle={'GET Request'}
                        title={'Polling Bookings'}
                        subtitle={'Use this guide to learn how to poll for new PRM bookings and bookings that have been updated or deleted since being received by the client.'}
                        prerequisites={[
                            'JSON Web Token',
                        ]}
                    />
                </Col>
            </Row>

            {/* Overview Authentication */}
            <Row>
                <Col >
                            
                    {/* Overview */}
                    <Text.Subheading>Overview</Text.Subheading>
                    <Text.Text>{`There are two types of bookings:`}</Text.Text>
                    <List list={['New Bookings', 'Bookings that have already been shared but required updates']} />
                    <Text.Text>A new booking is a PRM Booking that has been created on the portal or by a passenger and is stored on PRM Connect but has not been shared with the airline. The polling cycle works to retrieve all of these new bookings, once the booking has been received an acknowledgement must be sent, ensuring that the same booking does not get shared again.</Text.Text>
                    <Text.Text>Once a booking is received by the client, that booking information could change. For example, a passenger's flight date could change or they could change the assistance on the request. A passenger can go as far as deleting a booking. The GET Updated / Deleted request allows the client to request a list of bookings that they already have received but require updates or deletions.</Text.Text>
                </Col>
            </Row>

            {/* Section Tab Selector */}
            <Col >
                <TabList 
                    tabs={['Overview', 'Example', 'Polling Booking Integration', 'Polling Updates Integration', 'Implementation',]}
                    setTab={(value)=>{ setTab(value)}}
                />
            </Col>

            { tab == 1 &&
            <>

            {/* Authentication */}
            <Row className='mt-4' style={{borderWidth:border && 1, borderStyle: border && 'solid' }}>
                <Col >
                    <Container>
                        <Text.Subheading>1. Authorization</Text.Subheading>
                        <Text.Text>{'Authentication is achieved by means of a JSON Web Token, generated from a Client ID and Client Secret and using the authentication endpoint discussed in the Authentication Section'}</Text.Text>
                    </Container>
                </Col>
            </Row>

            {/* Request */}         
            <Row className='mt-3'>
                <Col >
                    <Container>
                        <Text.Subheading>2. Request</Text.Subheading>
                        <Text.Text>{'This section describes the Polling request with a detailed API structure, an example request and response, JSON schemas for request, responses and error response codes.'}</Text.Text>
                    </Container>
                </Col>
            </Row>
            
            {/* Overview 2.1 - Header Table */}
            <Row className='mt-2'>
                <Col >
                    <Container>
                        <Text.Subheading>2.1 Header</Text.Subheading>
                        <Text.Text>{'The request contains the following headers:'}</Text.Text>
                        <RequestHeader contentType={true} />
                    </Container>
                </Col>
            </Row>

            <Row className='mt-2'>
                <Col>
                    <Container>
                        <Text.Subheading>3.1 Request Query Parameters</Text.Subheading>
                        <Text.Text>{'The request contains the following query parameters:'}</Text.Text>
                        <RequestFields rows={[
                            { parameter:'skip', description:'Skips this number of bookings before returning bookings. Defaults to 0', example:'100', optional:'Optional'},
                            { parameter:'limit', description:'The limit on the number of matching results. This does not affect the counts. Defaults to 25', example:'300', optional:'Optional'},
                            { parameter:'patch', description:'Whether the poll response should return newly created bookings or updated bookings', example:'true', optional:'Optional'},
                        ]}
                        />
                        <Text.Text>{'The skip and limit fields can be used to implement pagination where queries return a large number of matchings bookings.'}</Text.Text>
                    </Container>
                </Col>
            </Row>
            {/* Overview 2.3 - Response */}
            <Row className='mt-5'>
                <Col >
                    <Container>
                        <Text.Subheading>2.3 Response</Text.Subheading>
                        <Text.Text>{'This section reviews the different responses and their meaning.'}</Text.Text>
                        <ResponseTable />
                    </Container>
                </Col>
            </Row>
            </>
            }

            { tab == 2 &&
            <>
            <Row className='mt-4'>
                <Col >
                   <Container>

                       {/* Text */}
                       <Text.Subheading>1. Example Request</Text.Subheading>
                       <Text.Text>{'This section contains an example of polling new bookings and polling updated bookings'}</Text.Text>

                       <Text.Subsubheading>1.1 Polling new bookings</Text.Subsubheading>
                       <Text.Text>{'In this example we get all new bookings for the client.'}</Text.Text>
                       
                       <Text.Subsubheading>1.2 Request</Text.Subsubheading>
                       <HttpRequest 
                            requestType={'GET'}
                            url={'https://connect.prmassist.com/api/v1/bookings/poll'}
                            headers={['Authorization: Bearer <token>', 'Content-Type: application/json']}
                        />
                   </Container>
               </Col>
           </Row>
            <Row className='mt-2'>
                <Col>
                    <Container>
                        <TableNumber title={'1.1 Request Response'} description={'Displays the response from the above request'} />
                        <CopyBlock
                            language={'json'}
                            text={sample['pollingNewBookings']}
                            showLineNumbers={false}
                            theme={dracula}
                            wrapLines={false}
                        />
                    </Container>
                </Col>
            </Row>
            <Row className='mt-4'>
                <Col >
                   <Container>

                       <Text.Subsubheading>1.2 Polling updated / deleted bookings</Text.Subsubheading>
                       <Text.Text>{'In this example we get all bookings that have been updated or deleted since being sent to the client.'}</Text.Text>
                       
                       <Text.Subsubheading>1.2 Request</Text.Subsubheading>
                       <HttpRequest 
                            requestType={'GET'}
                            url={'https://connect.prmassist.com/api/v1/bookings/poll'}
                            headers={['Authorization: Bearer <token>', 'Content-Type: application/json', 'Headers: { "update": true }']}
                        />
                   </Container>
               </Col>
           </Row>
            <Row className='mt-2'>
                <Col>
                    <Container>
                        <TableNumber title={'1.1 Request Response'} description={'Displays the response from the above request'} />
                        <CopyBlock
                            language={'json'}
                            text={sample['pollingNewBookings']}
                            showLineNumbers={false}
                            theme={dracula}
                            wrapLines={false}
                        />
                    </Container>
                </Col>
            </Row>
            </>
            }

            { tab === 3 && 
            <>
                <IntegrationRow 
                    title={'Polling New Bookings'}
                    description={'In this section, we outline how the API works to exchange bookings between the client and PRM Connect. In order to retrieve bookings, a polling GET request should be made to PRM Connect in a cyclical period.'}
                    description2={'Initially, a sent GET request will return all bookings that have not been shared with the airline. Each request after should be two-fold: A request to retrieve all new bookings and a request to retrieve all deleted/updated bookings. In this section, we will only examine the request cycle for getting new bookings, in the next section "Polling Updates Integration" we examine the polling cycle including a poll for deleted or updated bookings.'}
                />

                <IntegrationRow 
                    title={''}
                    description={''}
                    imageTitle={<TableNumber title={''} description={'Example of a Polling for new bookings stored in the PRM Connect'} />}
                    image={<img
                        src={GettingPRMBookings}
                        width="1000px"
                        className="d-inline-block align-top"
                        alt=""
                        style={{ marginBottom: 12}}
                    />}
                    imageDescription={'The inital GET request is sent by the client to PRM Connect. This request will retrieve all PRM bookings for that client. These bookings are then saved and acknowledged on the clients side. The Acknowledgement request allows PRM Connect to confirm that the group of bookings that have been shared with the client have been sucessfully saved. This results in bookings not being sent again, unless specifically requested. In the next request cycle period, a GET requests is sent to receive new bookings that have not yet been sent to the client.'}
                />  

            </>
            }

            { tab == 4 && 
            <>
                <IntegrationRow 
                    title={'Polling New and Updated Bookings'}
                    description={'In this section, we examine how to receive updates and deletion on bookings stored in the client database.'}
                    description2={'In the previous section, we examine how to retrieve new bookings in a polling cycle. This integration expands the polling cycle to include a second GET request to retrieve any updated or deleted bookings.'}
                    imageTitle={<TableNumber title={'New Polling Cycle'} description={'New polling cycle including request for updated and deleted bookings'} />}
                    image={<img
                        src={GettingPRMBookings}
                        width="1000px"
                        className="d-inline-block align-top"
                        alt=""
                        style={{ marginBottom: 12}}
                    />}
                    imageDescription={'The inital GET Request is sent by the client to PRM Connect to retrieve all new bookings. Once saved, the client sends an acknowledgement to have these bookings marked as received. A time period will pass, in this example one hour, and another polling cycle beings. In this polling cycle two request are made. One request is to retrieve all new bookings that have been created since the previous polling cycle, the other request retrieves any previous bookings that have been updated or deleted. '}
                />
                <Container>
                <Text.Text>This polling cycle repeates continuously, retrieving all new bookings created and retrieving all bookings which need to be updated.</Text.Text>
                </Container>
            </>
            }

            { tab == 5 &&
            <>
                <Row className='mt-4'>
                    <Col>
                        <Container>
                            <Text.Subheading>Swagger Implementation</Text.Subheading>
                            <Text.Text>{'This section contains a swagger that can be used for posting an example booking, reviewing the different responses and error codes'}</Text.Text>

                            <SwaggerUI url="poll.yaml" />
                        </Container>
                    </Col>
                </Row>
            </>
            }

            {/* Page Navigator */}
            <Row>
                <Col>
                    <Container>
                        <PageNavigator leftText={'Create Booking'} leftLink={'/create-booking'}  rightText={'Acknowledgements'} rightLink={'/acknowledgement'} />
                    </Container>
                </Col>
            </Row>
            
            <Footer small={true} />

        </>
    );
};

export default GettingUpdatedDeleted;
